import { z } from 'zod';
import { BOSS_ABILITY_KINDS } from '../data/bosses.js';
/**
 * Zone bosses (ADR 0024), server to client only: the client draws and
 * sounds what the server decided, and never answers these.
 */
const TileSchema = z.object({ x: z.number().int(), y: z.number().int() });
/** A shape turns red on the ground: whoever stands in it when `ms` runs out is hit. */
export const BossTelegraphEventSchema = z
    .object({
    mobId: z.string().min(1),
    kind: z.enum(BOSS_ABILITY_KINDS),
    centre: TileSchema,
    radius: z.number().int().min(0),
    /** Every tile it covers (ADR 0029): the shape, exactly as the server checks it. */
    tiles: z.array(TileSchema).max(400),
    ms: z.number().int().positive(),
})
    .strict();
/** The disc lands: the blow itself, for the shake and the thud. */
export const BossImpactEventSchema = z
    .object({
    mobId: z.string().min(1),
    kind: z.enum(BOSS_ABILITY_KINDS),
    centre: TileSchema,
    radius: z.number().int().min(0),
    tiles: z.array(TileSchema).max(400),
})
    .strict();
/** A threshold crossed: it calls its kin, or it rages. */
export const BossPhaseEventSchema = z
    .object({ mobId: z.string().min(1), phase: z.enum(['summon', 'enrage']) })
    .strict();
/**
 * The boss fell (ADR 0090), to its dungeon, and again to whoever comes in
 * while it lies dead: it stands up `ms` from now, for the countdown.
 */
export const BossRespawnEventSchema = z
    .object({ bossId: z.string().min(1), ms: z.number().int().nonnegative() })
    .strict();
//# sourceMappingURL=boss.js.map